import { render } from "./plane.vue?vue&type=template&id=2b21b757"
import script from "./plane.vue?vue&type=script&lang=js"
export * from "./plane.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__